import { AscendancyEmbedView } from '@/components/embeds/Ascendancy'
import Paperdoll, { ItemDisplay } from '@/components/embeds/Paperdoll'
import { loadProfile } from '@/embed/cache'
import {
  ItemNode,
  PassiveNode,
  ProfileItemNode,
  SkillNode
} from '@/embed/nodes'
import { decodeTooltipOptions } from '@/logic/item'
import Store, { StoreState } from '@/store'
import { ItemTooltip } from '@/tooltip'
import React, { ReactNode } from 'react'

const store = new Store()
function render(elem: ReactNode) {
  return <Store.Provider store={store}>{elem}</Store.Provider>
}

export function EmbedRenderer({
  type,
  id,
  profile,
  text,
  options = {}
}: {
  type: string
  id: number | string
  profile?: string
  text: ReactNode
  options?: {
    options?: string
    preview?: number | string
    tooltip?: any
    iconOnly?: any
    variant?: number | string
  }
}) {
  const [profileData, setProfileData] = React.useState<StoreState>()
  React.useEffect(() => {
    if (!profile || profile === 'true') return

    let current = true
    loadProfile(profile).then(
      (data) => {
        if (current) setProfileData(data)
      },
      () => {}
    )
    return () => {
      current = false
    }
  }, [profile])

  const store = React.useMemo(() => {
    return new Store(profileData)
  }, [profileData])

  switch (type) {
    case 'poe-passive':
      return render(<PassiveNode text={text} id={id} atlas={false} />)
    case 'poe-atlas':
      return render(<PassiveNode text={text} id={id} atlas={true} />)
    case 'poe-skill':
      return render(<SkillNode text={text} id={id.toString()} />)
    case 'poe-item':
      if (profile) {
        if (profileData) {
          const item = profileData?.items[Number(id)]
          if (item) {
            const parsedOptions = options.options
              ? decodeTooltipOptions(options.options)
              : undefined
            if (options.preview) {
              return (
                <span className="poeplanner-wrapper">
                  {render(
                    <ItemDisplay
                      item={item}
                      options={parsedOptions}
                      label={Boolean(Number(options.preview))}
                    />
                  )}
                </span>
              )
            } else if (options.tooltip) {
              return render(<ItemTooltip item={item} options={parsedOptions} />)
            } else {
              return render(
                <ProfileItemNode
                  text={text}
                  item={item}
                  icon={Boolean(options.iconOnly)}
                  options={parsedOptions}
                />
              )
            }
          }
        }
      } else {
        return render(
          <ItemNode
            text={text}
            id={id.toString()}
            icon={options.iconOnly}
            variant={options.variant}
          />
        )
      }
      break
    case 'poe-ascendancy':
      if (profile && profileData) {
        const embed = profileData.embeds.find((embed) => `${embed.id}` === id)
        if (embed?.type !== 'ascendancy') {
          return <span style={{ color: 'red' }}>Embed type mismatch</span>
        }

        if (embed?.steps) {
          return (
            <Store.Provider store={store}>
              <AscendancyEmbedView embed={embed} />
            </Store.Provider>
          )
        }
      }
      break
    case 'poe-equipment':
      if (profile && profileData) {
        const embed = profileData.embeds.find((embed) => `${embed.id}` === id)
        if (embed?.type !== 'equipment') {
          return <span style={{ color: 'red' }}>Embed type mismatch</span>
        }

        if (embed?.items) {
          return (
            <Store.Provider store={store}>
              <Paperdoll
                items={embed.items}
                selected={undefined}
                onSelect={undefined}
              />
            </Store.Provider>
          )
        }
      }
      break
  }

  return null
}
